import { defineChain, fallback, http } from 'viem';
import { cookieStorage, createStorage } from 'wagmi';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { mainnet, bsc, tron } from 'viem/chains';

export const projectId = String(process.env.NEXT_PUBLIC_REOWN_PROJECT_ID);

export const solarious = defineChain({
  id: 804223,
  name: 'Solarious',
  nativeCurrency: { decimals: 18, name: 'Solarious', symbol: 'SOLAR' },
  rpcUrls: { default: { http: ['https://rpc-testnet.solarious.io'] } },
  contracts: {
    multicall3: { address: '0xcA11bde05977b3631167028862bE2a173976CA11', blockCreated: 0 },
  },
  blockTime: 4000,
  blockExplorers: {
    default: { name: 'Solarious Explorer', url: 'https://explorer-testnet.solarious.io' },
  },
});

export const chain = solarious;

const schema = [{ url: 'https://rpc-testnet.solarious.io' }];

export const customRpcUrls: Record<`eip155:${number}`, typeof schema> = {
  [`eip155:${chain.id}`]: schema,
};

export const wagmiAdapter = new WagmiAdapter({
  networks: [mainnet, bsc, tron, chain],
  chains: [mainnet, bsc, tron, chain],
  projectId,
  ssr: true,
  storage: createStorage({ storage: cookieStorage }),
  batch: { multicall: true },
  cacheTime: chain.blockTime / 3,
  transports: { [chain.id]: fallback(schema.map((rpc) => http(rpc.url))) },
});

export const config = wagmiAdapter.wagmiConfig;
